import { HttpErrorResponse, HttpInterceptorFn } from '@angular/common/http';
import { StorageService } from '../../services/storage/storage.service';
import { AuthService } from '../../services/auth/auth.service';
import { inject } from '@angular/core';
import { catchError, throwError } from 'rxjs';

export const authInterceptor$: HttpInterceptorFn = (req, next) => {
  const auth: AuthService = inject(AuthService);
  const storage: StorageService = inject(StorageService);

  const accessToken = storage.get('accessToken');

  if (accessToken) {
    req = req.clone({
      setHeaders: {
        Authorization: `Bearer ${accessToken}`,
        'Access-Control-Allow-Origin': '*',
        'Access-Control-Allow-Methods': '*',
      },
    });
  }

  return next(req).pipe(
    catchError((error: HttpErrorResponse) => {
      const data = {
        reason: error?.error?.reason ?? '',
        status: error.status,
        causedBy: error.message,
      };

      auth.collectFailedRequest(data);
      return throwError(()=> error);
    })
  );
};
